import React, {Component} from 'react';
import EtelAPI from '../api/EtelAPI';

export default class DashboardTile extends Component {
  constructor( props ) {
    super( props );
    this.intervalHandle = 0;
    this.MINIMUM_REFRESH_DURATION = 1000;
    
    this.dataTypes = {
      'string': true,
      'number': true,
      'decimal': true
    };
    
    this.defaultValues = {
      'string': '',
      'number': 0,
      'decimal': 0.00
    }

    this.state = {
      caption: props.caption === undefined ? '' : props.caption,
      duration: props.duration === undefined ? '' : props.duration,
      normal: props.normal === undefined ? -1 : props.normal,
      warning: props.warning === undefined ? -1 : props.warning,
      alert: props.alert === undefined ? -1 : props.alert,
      dataType: props.dataType === undefined ? 'string' : props.dataType,
      route: props.route === undefined ? '' : props.route,
      mappedField: props.mappedField === undefined ? '' : props.mappedField,
      parameters: props.parameters === undefined ? [] : props.parameters,
      refreshEnabled: props.refreshEnabled === undefined ? false : props.refreshEnabled,
      refreshDuration: props.refreshDuration === undefined ? -1 : props.refreshDuration,
      value: this.getDefaultValue( props.dataType ),
    };

    this.getData = this.getData.bind( this );
  }

  componentDidMount( ) {
  
    // Populate initial data
    this.getData();

    // Check if refresh timer is enabled
    const refreshEnabled = this.state.refreshEnabled;
    if( refreshEnabled === true ) {
      // If enabled is true then get the refresh duration
      let refreshDuration = this.state.refreshDuration;
      // make sure that refresh duration is always 1 second or more
      refreshDuration = refreshDuration < this.MINIMUM_REFRESH_DURATION ? this.MINIMUM_REFRESH_DURATION : refreshDuration;
      // Create the timer
      this.intervalHandle = setInterval( ( ) => {
        this.getData();
      }, refreshDuration );
    }
  }

  componentWillUnmount() {
    const refreshEnabled = this.state.refreshEnabled;
    // Check if refresh timer is enabled
    if( refreshEnabled === true ) {
      // Make sure the timer was created
      if( this.intervalHandle !== 0 ) {
        clearInterval( this.intervalHandle );
        this.intervalHandle = 0;
      }
    }
  }

  static getDerivedStateFromProps( props, state ) {
    let newState = state;
    let stateChanged = false;
    // caption property changed
    if( props.caption !== undefined ) {
      if( props.caption !== state.caption ) {
        newState.caption = props.caption;
        stateChanged = true;
      }
    }

    // duration property changed
    if( props.duration !== undefined ) {
      if( props.duration !== state.duration ) {
        newState.duration = props.duration;
        stateChanged = true;
      }
    }
 
    // normal property changed
    if( props.normal !== undefined ) {
      if( props.normal !== state.normal ) {
        newState.normal = props.normal;
        stateChanged = true;
      }
    }

    // warning property changed
    if( props.warning !== undefined ) {
      if( props.warning !== state.warning ) {
        newState.warning = props.warning;
        stateChanged = true;
      }
    }

    // alert property changed
    if( props.alert !== undefined ) {
      if( props.alert !== state.alert ) {
        newState.alert = props.alert;
        stateChanged = true;
      }
    }
    
    // route property changed
    if( props.route !== undefined ) {
      if( props.route !== state.route ) {
        newState.route = props.route;
        stateChanged = true;
      }
    }
    
    // mappedField property changed
    if( props.mappedField !== undefined ) {
      if( props.mappedField !== state.mappedField ) {
        newState.mappedField = props.mappedField;
        stateChanged = true;
      }
    }

    // dataType property changed
    if( props.dataType !== undefined ) {
      if( props.dataType !== state.dataType ) {
        newState.dataType = props.dataType;
        stateChanged = true;
      }
    }

    // parameters property changed
    if( props.parameters !== undefined ) {
      if( props.parameters.length !== state.parameters.length ) {
        newState.parameters = props.parameters;
        stateChanged = true;
      } else {
        let sourceKeys = Object.keys( state.parameters );
        let newSourceKeys = Object.keys( props.parameters );
        if( sourceKeys.length !== newSourceKeys.length ) {
          newState.parameters = props.parameters;
          stateChanged = true;
        } else {
          for( var index = 0; index < sourceKeys.length; index++ ) {
            const sourceKey = sourceKeys[ index ];
            const newSourceKey = newSourceKeys[ index ];
            if( sourceKey !== newSourceKey ) {
              newState.parameters = props.parameters;
              stateChanged = true;
            }
          }
        }
      }
    }

    // refreshEnabled property changed
    if( props.refreshEnabled !== undefined ) {
      if( props.refreshEnabled !== state.refreshEnabled ) {
        newState.refreshEnabled = props.refreshEnabled;
        stateChanged = true;
      }
    }
    
    // refreshDuration property changed
    if( props.refreshDuration !== undefined ) {
      if( props.refreshDuration !== state.refreshDuration ) {
        newState.refreshDuration = props.refreshDuration;
        stateChanged = true;
      }
    }
    
    // check if state is changed 
    // if changed state to update render
    if( stateChanged === true ) {
      return newState;
    }
    
    // return no change
    return null;
  }

  getData() {
    const route = this.state.route;
    const parameters = this.state.parameters;
    const mappedField = this.state.mappedField;
    const dataType = this.state.dataType;
    if( route !== '' ) {
      const api = new EtelAPI( route );
      api.get( parameters ).then( ( result ) => {
        const row = result[ 0 ];
        let value = 0;
        if( mappedField !== '' ) {
          if( row[ mappedField ] !== undefined ) {
            if( dataType === 'number' ) {
              value = parseInt( row[ mappedField ], 10 );
            } else if( this.state.dataType === 'decimal' ) {
              value = parseFloat( row[ mappedField ] ).toFixed( 2 );
            } else {
              value = row[ mappedField ].toString();
            }
          } else {
            value = this.getDefaultValue( dataType );
          }
        }
        this.setState( { 
          value: value
        } );
      } ).catch( ( exception ) => {
        this.setState( {
          value: this.getDefaultValue( dataType )
        } );
      });
    }
  }

  getDefaultValue( dataType ) {
    const valueDataType = dataType === undefined ? 'string' : dataType;
    if( this.defaultValues[ valueDataType ] === undefined ) {
      return this.defaultValues[ 'string' ]
    } else {
      return this.defaultValues[ valueDataType ];
    }
  }

  getNormalValue( dataType ) {
    let valueDataType = dataType === undefined ? 'string' : dataType;
    if( this.defaultValues[ valueDataType ] !== undefined ) {
      if( valueDataType === 'number' ) {
        return parseInt( this.state.normal, 10 );
      } else if( valueDataType === 'decimal' ) {
        return parseFloat( this.state.normal ).toFixed( 2 );
      } else {
        return this.state.normal.toString();
      }
    } else {
      return this.state.normal.toString();
    }
  }

  getWarningValue( dataType ) {
    let valueDataType = dataType === undefined ? 'string' : dataType;
    if( this.defaultValues[ valueDataType ] !== undefined ) {
      if( valueDataType === 'number' ) {
        return parseInt( this.state.warning, 10 );
      } else if( valueDataType === 'decimal' ) {
        return parseFloat( this.state.warning ).toFixed( 2 );
      } else {
        return this.state.warning.toString();
      }
    } else {
      return this.state.warning.toString();
    }
  }

  getAlertValue( dataType ) {
    let valueDataType = dataType === undefined ? 'string' : dataType;
    if( this.defaultValues[ valueDataType ] !== undefined ) {
      if( valueDataType === 'number' ) {
        return parseInt( this.state.alert, 10 );
      } else if( valueDataType === 'decimal' ) {
        return parseFloat( this.state.alert ).toFixed( 2 );
      } else {
        return this.state.alert.toString();
      }
    } else {
      return this.state.alert.toString();
    }
  }

  render( ) {
    let tileClassName='dashboard-tile';
    const value = this.state.value;
    const normal = this.getNormalValue( this.state.dataType );
    const warning = this.getWarningValue( this.state.dataType );
    const alert = this.getAlertValue( this.state.dataType );

    if( normal !== -1 ) {
      if( value >= warning && value < alert ) {
        tileClassName += ' tile-warning';
      } else if( value >= alert ) {
        tileClassName += ' tile-alert';
      } else {
        tileClassName += ' tile-normal';
      }
    } else {
      tileClassName += ' tile-normal';
    }

    if( value !== '' ) {
      const style = this.props.style;
      return (
        <div className={tileClassName} style={style}>
          <div className="dashboard-tile-header">
            <div className="dashboard-tile-cell-1">
              <span className="dashboard-tile-caption">
                {this.state.caption}
              </span>
            </div>              
            <div className="dashboard-tile-cell-2">
              <span>
                {this.state.duration}
              </span>
            </div>              
          </div>
          <div className="dashboard-tile-content">
            {this.state.value}
          </div>
        </div>
      );
    } else {
      return (<div></div>);
    }
  }
}


// WEBPACK FOOTER //
// ./src/presentation/DashboardTile.js